// extracted by mini-css-extract-plugin
module.exports = {"remoteWork":"OpenToOffers_remoteWork__3M9oG","container":"OpenToOffers_container__1mMGp"};